<template>
    <div class="dropdown" :class="{'open' : open}">
        <input
            v-model="query"
            v-bind:id="'input' + id"
            type="text"
            class="form-control"
            :placeholder="placeholder"
            @input="searchChanged"
            @keydown.enter="itemSelected(items[highlightIndex])"
            @keydown.down="down"
            @keydown.up="up"
            @keydown.esc="setOpen(false)"
            @blur="setOpen(false)"
        >
        <ul v-show="query.length > 2" class="dropdown-menu" v-bind:class="{ 'show': open }" v-bind:id="'dropdown' + id">
            <li v-for="(item, index) in items" :key="item" @mousedown.prevent @click="itemSelected(item)" class="dropdown-item" :class="{'active' : index === highlightIndex}" v-bind:title="item">
                {{item}}
            </li>
            <li v-show="isEmpty">Ingen holdeplasser</li>
            <li v-show="noResults" class="dropdown-item">Fant ingen holdeplasser</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Typeahead',
        props: {
            source: {
                type: [String, Array],
                required: true
            },
            filterKey: {
                type: String,
                required: true
            },
            startAt: {
                type: Number,
                default: 2
            },
            placeholder: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: "input"
            },
       },
       data() {
            return {
                items: [],
                query: '',
                open: false,
                highlightIndex: 0,
                noResult: false
            }
        },
        methods: {
            fetchItems(search) {
                if (typeof this.source === 'string') {
                    fetch(this.source + search).then(function (response) {
                      return response.json();
                    }).then(
                        data => this.items = data
                    );
                }
            },
            searchChanged () {
              if (!this.open) {
                this.open = true
              }
              this.highlightIndex = 0
            },
            up () {
              if (this.open) {
                if (this.highlightIndex > 0) {
                  this.highlightIndex--
                }
              } else {
                this.open = true
              }
            },
            down () {
              if (this.open) {
                if (this.highlightIndex < this.items.length - 1) {
                  this.highlightIndex++
                }
              } else {
                this.open = true
              }
            },
            setOpen(){
              this.open = false
            },
            itemSelected (item) {
              this.open = false
              this.query = item
              this.$emit('input', item[1])
            }  
        }, 
        computed: {
            filtered() {
                if(this.query.length >= this.startAt) {
                  return this.fetchItems(this.query);
                }
            },
            isEmpty() {
                if(typeof this.filtered === 'undefined') {  
                    return false
                } else {
                    return this.filtered.length < 1
                }
            },
            noResults(){
                if(this.items.length === 0){
                    return true
                }
            }
        }
    }
</script>

